import { browser } from "../../../services/device/device"

export const isChromeDesktop = () => {
    return getBrowserName().includes('chrome')
}

export const isSafari = () => {
    return getBrowserName().includes('safari')
}

export const isSafariDesktop = () => {
    return getBrowserName().includes('safari')
}

export const isSafariMobile = () => {
    return getBrowserName().includes('safari') && navigator.maxTouchPoints > 1
}

export const isFirefoxDesktop = () => {
    return getBrowserName().includes('firefox')
}

export const isEdgeDesktop = () => {
    return getBrowserName().includes('edge')
}

/**
 * True on a desktop-class platform (Chromebooks report 'desktop'). The is*Desktop
 * helpers above only match the browser name, so Chrome on iOS/Android passes them.
 */
export const isDesktopPlatform = () => {
    const type = browser.getPlatformType && browser.getPlatformType()
    return typeof type === 'string' && type.toLowerCase() === 'desktop'
}

export const getBrowserName = () => {
    const name = browser.getBrowserName()
    if(name){
        return name.toLowerCase()
    }
    return ""
}